import axiosInstance from "../../utils/axiosConfig";
import React, { useState } from "react";
import { API_URL } from "../../constant";
import { TailSpin } from "react-loader-spinner";

const RejectionModal = ({
  setOpenReject,
  customerDeet,
  actionLevel = 2,
  setError,
  setDeclineloader,
  setSuccess,
  setRefetch,
  declineloader,
  setOpenCustomerLog,
}: any) => {
  const [reason, setReason] = useState<string>("");
  const userId = customerDeet?.kyc2?.data?.userId ?? customerDeet?._id;
  const logId = customerDeet?.kyc2?.data?._id;

  const handleDecline = () => {
    if (declineloader) return;
    const data = { status: "Rejected", rejectionReason: reason };
    if (actionLevel === 3) {
      if (!logId) return;
      setDeclineloader(true);
      axiosInstance
        .put(`${API_URL}api/users/me/kyc/4/${userId}`, data)
        .then(() => {
          setDeclineloader(false);
          setOpenReject(false);
          setSuccess(`Level ${actionLevel} rejected successfully`);
          setRefetch((prev: number) => prev + 1);
          setTimeout(() => {
            setSuccess("");
            setOpenCustomerLog(false);
          }, 2000);
        })
        .catch((e: any) => {
          setError(e.response?.data?.message ?? "Request failed");
          setDeclineloader(false);
          setTimeout(() => setError(""), 4000);
        });
    } else {
      if (!userId || !logId) return;
      setDeclineloader(true);
      axiosInstance
        .put(`${API_URL}api/users/me/kyc/3/${userId}/${logId}`, data)
        .then(() => {
          setDeclineloader(false);
          setOpenReject(false);
          setSuccess(`Level ${actionLevel} rejected successfully`);
          setRefetch((prev: number) => prev + 1);
          setTimeout(() => {
            setSuccess("");
            setOpenCustomerLog(false);
          }, 2000);
        })
        .catch((e: any) => {
          setError(e.response?.data?.message ?? "Request failed");
          setDeclineloader(false);
          setTimeout(() => setError(""), 4000);
        });
    }
  };
  const validate = (reason: string) => {
    if (!reason) {
      setError("Kindly enter a reason for rejection");
      setTimeout(() => {
        setError("");
      }, 2000);
      return false;
    }
    setError("");
    return true;
  };
  const handleSubmit = () => {
    if (!validate(reason)) {
      return;
    }
    handleDecline();
  };
  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start overflow-auto pt-16 pb-16  bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="w-11/12 mds:w-10/12 lgss:w-[35%] transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] ">
        <div className="flex  pt-4 justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Reject Level {actionLevel}
          </h4>
          <h4
            onClick={() => setOpenReject(false)}
            className="text-[#78C2F7] font-medium text-[14px] cursor-pointer"
          >
            Close
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div className="">
            <label className=" font-bold text-white">Reason</label>
            <input
              placeholder="Rejection reason"
              name="reason"
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="h-[48px] w-full mt-2  px-[16px] text-[14px]   font-manrope border rounded-xl border-[#141414] outline-none bg-[#1C2227]  text-[#A0A9AD] transition duration-200"
            />
          </div>
          <button
            disabled={!reason}
            onClick={handleSubmit}
            className={
              !reason
                ? "w-full h-[50px] mt-6 rounded-xl bg-gray-400 text-[16px] text-gray-200 font-medium "
                : "w-full h-[50px] mt-6 rounded-xl bg-secondary_button flex justify-center items-center text-[16px] text-white font-medium "
            }
          >
            {declineloader ? (
              <TailSpin color="#FFFFFF" height={30} width={30} />
            ) : (
              `Decline Level ${actionLevel}`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
